import { IconKey } from 'govwell-ui/components/Icon/util'

import IconSelect from 'src/components/Selects/IconSelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  field: TanstackField<IconKey, TKey>
}
const IconSelectField = <TKey extends string>({ field }: Props<TKey>) => {
  return <IconSelect onValueChange={field.setValue} value={field.state.value} />
}

export default IconSelectField
